import styled from 'styled-components';

const Icon = styled.div`
  background-image: ${({ url }) => `url(${url})`};
  width: 100%;
  margin:0 auto;
  background-size: cover;
  background-position: center center;
  padding-bottom:66%;
`;

export default Icon;



// WEBPACK FOOTER //
// ./src/pages/Blog/BlogArticleBox/Icon.jsx